import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { ApplicationState } from '../../store';
import { useTranslation } from 'react-i18next';
import { useMsal } from '@azure/msal-react';
import { Customer } from '../../interfaces/Customer';
import { customersActionCreators } from '../../store/customers';
import { ContactsActionCreators } from '../../store/contacts';
import { TeamsState } from '../../store/TeamsState';
import { dataActionCreators } from '../../store/Data';
import { Button, Skeleton, SkeletonItem, Text } from '@fluentui/react-components';
import { Dismiss24Filled, Edit24Filled, PeopleTeam24Filled } from "@fluentui/react-icons";
import { useQuickViewStyles } from '../Styles/QuickView';
import { useContacts, useRigths } from '../Tools/ObjectLoader';

export const CustomersQuickView = () => {
    const customerQuickView = useSelector<ApplicationState, Customer | null>((state: ApplicationState) => state.customersState.customerQuickView);
    const dispatch = useDispatch();
    const { t } = useTranslation();
    const { instance } = useMsal();
    const teamsState = useSelector<ApplicationState, TeamsState>((state: ApplicationState) => state.teamsState);
    const viewDebugInfo = useSelector((state: ApplicationState) => state.userNeomyticLogin.viewDebugInfo);
    const { contacts, contactsLoading } = useContacts();
    const { isAdmin } = useRigths();
    const styles = useQuickViewStyles();

    React.useEffect(() => {
        // Load customer contact if not already done
        if (contacts && !contactsLoading && customerQuickView && customerQuickView.customerid && !customerQuickView.contactsLoading && (customerQuickView.contacts === null || customerQuickView.contacts === undefined)) {
            dispatch(customersActionCreators.requestCustomerContacts(instance, teamsState, customerQuickView.customerid));
        }
    }, [instance, teamsState, customerQuickView, contacts, contactsLoading]);

    if (customerQuickView) {
        const custList: JSX.Element[] = [];
        contacts && customerQuickView.contacts && customerQuickView.contacts.map((c) => {
            const con = contacts.find(x => x.contactid === c.contactid);
            if (con) {
                custList.push(<div className={styles.titleAndOps}>
                    <Button appearance="transparent" style={{ padding: "0", border: "0", justifyContent: "start" }} onClick={() => dispatch(ContactsActionCreators.requestContactQuickView(con))} >{con.firstName + " " + con.lastName}</Button>
                    <Text truncate>{c.relationShipTypeId ? t(c.relationShipTypeId) : "?"}</Text>
                </div>);
            }
        });

        return (
            <div className={styles.root} >
                <div className={styles.titleAndOps}>
                    <h2>{t('Customer') + " : " + (customerQuickView.displayName ? customerQuickView.displayName : "?")}</h2>
                    <div className={styles.titleAndOpsButtons}>
                        {isAdmin && <Button icon={<Edit24Filled />} shape="circular" title={t('Edit')} onClick={() => dispatch(customersActionCreators.requestCustomerEdition(customerQuickView))} />}
                        <Button icon={<Dismiss24Filled />} shape="circular" title="Close" onClick={() => dispatch(dataActionCreators.requestClearQuickView())} />
                    </div>
                </div>
                {viewDebugInfo &&
                    <>
                        <h2>Id</h2>
                        <Text truncate>{customerQuickView.customerid}</Text>
                    </>
                }
                <h2>{t('CompanyName')}</h2>
                {customerQuickView.name && <Text truncate>{customerQuickView.name}</Text>}
                <h2>{t('Address')}</h2>
                {customerQuickView.address && <Text truncate>{customerQuickView.address}</Text>}
                {customerQuickView.address2 && <Text truncate>{customerQuickView.address}</Text>}
                {customerQuickView.address3 && <Text truncate>{customerQuickView.address}</Text>}
                {customerQuickView.postalCode && <Text truncate>{customerQuickView.postalCode}</Text>}
                {customerQuickView.city && <Text truncate>{customerQuickView.city}</Text>}
                {customerQuickView.country && <Text truncate>{customerQuickView.country}</Text>}
                {isAdmin &&
                    <>
                        <h2>{t('PaymentTerms')}</h2>
                        {customerQuickView.paymentTerms ? <Text truncate>{customerQuickView.paymentTerms + t('Days')}</Text> : <Text truncate>30 {t('Days')}</Text>}
                        {customerQuickView.vatexempt && <Text truncate>{t('VATExempt')}</Text>}

                        <div className={styles.titleAndOps}>
                            <h2>Contacts</h2>
                            <Button icon={<PeopleTeam24Filled />} shape="circular" title={t('People')} onClick={() => dispatch(customersActionCreators.requestCustomerContactsEdition(customerQuickView))} />
                        </div>

                        {customerQuickView.contacts !== null
                            ? (custList.length > 0
                                ? custList.map(i => i)
                                : <Text>{t('NotDefined')}</Text>)
                            : <Skeleton>
                                <SkeletonItem />
                            </Skeleton>
                        }
                        {customerQuickView.peppolIdentifier &&
                            <>
                                <h2>{t('PeppolParticipantId')}</h2>
                                <Text truncate>{customerQuickView.peppolIdentifier}</Text>
                            </>
                        }
                    </>
                }
            </div>
        );
    }
    return null;
};